import React from "react";
import "./App.css";
// import Header from "./components/Header";
// import Hero from "./components/Hero";
// import Services from "./components/Services";
// import HowItWorks from "./components/HowItWorks";
// import Benefits from "./components/Benefits";
// import Testimonials from "./components/Testimonials";
// import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <div className="under-construction">
        <div className="construction-icon">🚧</div>
        <h1 className="construction-title">Site Under Construction</h1>
        <p className="construction-message">
          We're working hard to bring you something amazing. Check back soon!
        </p>
      </div>

      {/* Commented out existing content */}
      {/* <Header />
      <Hero />
      <Services />
      <HowItWorks />
      <Benefits />
      <Testimonials />
      <Footer /> */}
    </div>
  );
}

export default App;
